export default __webpack_public_path__ + "static/media/temp stay study program.8ec184ee.jpg";